import { ReactNode } from 'react'
import { Link } from 'react-router'

import { pages } from '~/app/routes'
import { AstraBadge, AstraParagraph, AstraSideNavTrigger, AstraTooltip, semanticColors } from '~/astra'
import { useStore } from '~/store/store'

import { Bar } from './Bar'
import { PeriodStatusIcon } from './PlanningPeriods/PeriodStatusIcon'
import { ProgressStatus } from './PlanningPeriods/shared/utils'

type Props = {
    title: ReactNode
    planningPeriodId?: number | null
    planningPeriodName?: string | null
    planningPeriodIsPublished?: boolean | null
    planningPeriodProgressStatus?: ProgressStatus | null
    planningPeriodCalculatedProgress?: number
    planningPeriodWeekRange?: string | null

    actions?: ReactNode
    viewSwitcher?: ReactNode
}

export const PageTitleBar = ({
    title,
    planningPeriodId,
    planningPeriodName,
    planningPeriodIsPublished,
    planningPeriodProgressStatus,
    planningPeriodCalculatedProgress,
    planningPeriodWeekRange,
    actions,
    viewSwitcher,
}: Props) => {
    const isNavSidebarOpen = useStore(state => state.app.isNavSidebarOpen)
    const setIsNavSidebarOpen = useStore(state => state.app.actions.setIsNavSidebarOpen)
    const hasPlanningPeriod = planningPeriodId !== undefined && planningPeriodId !== null && planningPeriodName

    return (
        <Bar
            left={
                <div className="flex h-full items-center gap-2">
                    <AstraSideNavTrigger isOpen={isNavSidebarOpen} toggleOpen={() => setIsNavSidebarOpen(!isNavSidebarOpen)} />

                    {typeof title === 'string' ? <AstraParagraph weight="medium">{title}</AstraParagraph> : title}
                    {viewSwitcher && (
                        <>
                            <div className="h-[18px] w-[1px] border-r border-strong" />
                            {viewSwitcher}
                        </>
                    )}
                    {hasPlanningPeriod && (
                        <>
                            <div className="h-[18px] w-[1px] border-r border-strong" />
                            {planningPeriodProgressStatus && (
                                <PeriodStatusIcon status={planningPeriodProgressStatus} progress={planningPeriodCalculatedProgress} />
                            )}
                            <AstraTooltip tooltipContent={planningPeriodWeekRange}>
                                <Link to={`${pages.PERIODS_OVERVIEW.views.periods.path}/${planningPeriodId}`}>
                                    <AstraParagraph className="pr-1 hover:underline">{planningPeriodName}</AstraParagraph>
                                </Link>
                            </AstraTooltip>
                            <AstraBadge
                                text={planningPeriodIsPublished ? 'Publisert' : 'Utkast'}
                                color={planningPeriodIsPublished ? semanticColors.bg['brand-strong-rest'] : 'default'}
                            />
                        </>
                    )}
                </div>
            }
            right={actions ? <div className="flex gap-2">{actions}</div> : undefined}
        />
    )
}
